import React from 'react';

import SelectVINDescription from './SelectVINDescription';
import SelectVINFile from '../SelectVINs/SelectVINFile';
import SelectBypassNotificationOptOut from './SelectBypassNotificationOptOut';

interface IVINsProps {
  initialVINFileName: string | undefined;
  selectedVINFileName: string | undefined;
  setSelectedVINFileName: Function;

  initialVINDescription: string | undefined;
  selectedVINDescription: string | undefined;
  setSelectedVINDescription: Function;

  initialBypassUserNotificationOptOut: boolean | undefined;
  bypassUserNotificationOptOut: boolean;
  setBypassUserNotificationOptOut: Function;

  initialVINFileGUID: string | undefined;
  selectedVINFileGUID: string | undefined;
  setSelectedVINFileGUID: Function;

  listOfWMIs: string | undefined;
  setListOfWMIs: Function;

  onChange: Function;
  readOnly: boolean;
}

export default function SelectVINs(props: IVINsProps) {
  const {
    initialVINFileName, selectedVINFileName, setSelectedVINFileName,
    initialVINDescription, selectedVINDescription, setSelectedVINDescription,
    initialBypassUserNotificationOptOut, bypassUserNotificationOptOut, setBypassUserNotificationOptOut,
    initialVINFileGUID, selectedVINFileGUID, setSelectedVINFileGUID,
    listOfWMIs, setListOfWMIs, onChange, readOnly
  } = props;

  return (<div>
    <SelectVINFile
      initialValue={initialVINFileName}
      selectedVINFileName={selectedVINFileName}
      setSelectedVINFileName={setSelectedVINFileName}
      initialVINFileGUID={initialVINFileGUID}
      selectedVINFileGUID={selectedVINFileGUID}
      setSelectedVINFileGUID={setSelectedVINFileGUID}
      setListOfWMIs={setListOfWMIs}
      onChange={() => onChange()}
      readOnly={readOnly} />
    <SelectVINDescription initialValue={initialVINDescription}
      selectedVINDescription={selectedVINDescription}
      setSelectedVINDescription={setSelectedVINDescription}
      listOfWMIs={listOfWMIs}
      onChange={() => onChange()}
      readOnly={readOnly} />
    <SelectBypassNotificationOptOut
      initialBypassUserNotificationOptOut={initialBypassUserNotificationOptOut}
      bypassUserNotificationOptOut={bypassUserNotificationOptOut}
      setBypassUserNotificationOptOut={setBypassUserNotificationOptOut}
      onChange={() => onChange()}
      readOnly={readOnly}
    />
  </div>
  )
}